import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';

import { ExclusiveDealsBenefit, ImpactBenefit, ShippingBenefit } from 'features/paid-membership/Benefits';

function BenefitsListV2({ layout = 'responsive' }) {
    const withinHorizontalBreakpoint = useMediaQuery({ maxWidth: 539 });

    const listOrientation = layout === 'horizontal' || withinHorizontalBreakpoint ? 'horizontal' : 'vertical';

    return (
        <ul className={clsx('gap-10', listOrientation === 'horizontal' ? 'flex flex-col' : 'grid grid-cols-3')}>
            <li>
                <ExclusiveDealsBenefit layout={listOrientation} />
            </li>
            <li>
                <ShippingBenefit layout={listOrientation} />
            </li>
            <li>
                <ImpactBenefit layout={listOrientation} />
            </li>
        </ul>
    );
}

export { BenefitsListV2 };
